import { Stack } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2"
import { ReactElement } from "react"

import AppSkeleton from "./appSkeleton"
import { GRID_SPACING } from "../../../themes/defaultThemeParams"

const COLUMNS = 12

const SingleApplicationSkeleton = (): ReactElement => (
    <Stack spacing={GRID_SPACING}>
        <AppSkeleton height={80} aria-label="SingleApplicationSkeleton" />
        <Grid
            container
            spacing={GRID_SPACING}
            sx={{ flexWrap: { lg: "nowrap" } }}
        >
            <Grid lg={3} xs={COLUMNS}>
                <Stack spacing={GRID_SPACING}>
                    <AppSkeleton sx={{ minHeight: 375 }} height="100%" />
                    <AppSkeleton height={100} />
                    <AppSkeleton height={100} />
                    <AppSkeleton height={100} />
                    <AppSkeleton height={100} />
                </Stack>
            </Grid>
            <Grid lg={9} xs={COLUMNS}>
                <Stack spacing={GRID_SPACING}>
                    <AppSkeleton height={175} />
                    <Grid
                        container
                        spacing={GRID_SPACING}
                        sx={{ flexWrap: { lg: "nowrap" } }}
                    >
                        <Grid lg={6} xs={COLUMNS}>
                            <Stack spacing={GRID_SPACING}>
                                <AppSkeleton height={600} />
                                <AppSkeleton height={600} />
                            </Stack>
                        </Grid>
                        <Grid lg={6} xs={COLUMNS}>
                            <AppSkeleton height={1200} />
                        </Grid>
                    </Grid>
                </Stack>
            </Grid>
        </Grid>
    </Stack>
)

export default SingleApplicationSkeleton
